export default __webpack_public_path__ + "static/media/close.fdf178a6.svg";